import axios from "axios";
import { config } from "../../../../../enviroment";


export const PaymentService = {
    postPayment,
    prepayment,
    getPrechargeBreakupDetails
  };
  const tenantCode = config.parameters.TENANT_CODE;
  const BKASH_GATEWAY ="BKASH_GATEWAY"
  const QUICK_PAY="QUICK_PAY"
  const PRECHARGE_TRANSACTION_ID = localStorage.getItem('preChargeTransactionId')
  // const PRECHARGE_TRANSACTION_ID = ""
  async function postPayment(paymentID,status,customerNo) {
    let APIquery =
      `query{  postPaymentProcessing(input:{

        RequestInput:{
        
        paymentID:"`+paymentID+`",
        
        paymentType:"`+BKASH_GATEWAY+`"
        
        tenantcode: "`+tenantCode+`",
        
        status:"`+status+`"

        customerNumber:"`+customerNo+`",

        preChargeTransactionId:"`+PRECHARGE_TRANSACTION_ID+`"

        sourceType:"`+QUICK_PAY+`"
        
            }
        
        }) }`;
    return new Promise((resolve, reject) => {
      axios({
        url: config.urls.USAGE_SERVICE_BASE_URL,
        method: "post",
        data: {
          query: APIquery,
        },
      })
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
  
  async function prepayment(amount,customerId,email) {
    let APIquery =
    `query{  prePaymentProcessing(input:{

        RequestInput:{
        
        amount: `+amount+`,
        
        customerNumber:"`+customerId+`",
        
        email:"`+email+`",
        
        paymentType:"`+BKASH_GATEWAY+`",
        
        tenantcode: "`+tenantCode+`",

        sourceType:"`+QUICK_PAY+`"
        
            }
        
        }) }`;
    return new Promise((resolve, reject) => {
      axios({
      url: config.urls.USAGE_SERVICE_BASE_URL,
        method: "post",
        data:{
           query:APIquery,
        }
      })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  async function getPrechargeBreakupDetails({customerNo, meterNo, payinAmount, TenderSource, TenderType, tenantCode}) {
    let APIquery =
    `query{  getPreChargeBreakupDetails(input: {

      customerNo:"`+customerNo+`",
  
      meterNo:"`+meterNo+`",
  
      payinAmount:"`+payinAmount+`",
  
      TenderSource:"`+TenderSource+`",

      tenantCode:"`+tenantCode+`",
  
      TenderType:"`+TenderType+`"
  
      })}`;
    return new Promise((resolve, reject) => {
      axios({
      url: config.urls.USAGE_SERVICE_BASE_URL,
        method: "post",
        data:{
           query:APIquery,
        }
      })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  
  export default PaymentService;